import {BaseModel} from '../common/base/base-model';

export class LawConservation extends BaseModel {
}
